<template>
  <div>
    <template v-if="currentImage">
      <div
        class="text-xs-center"
        style="
          position: relative;
          overflow: hidden;
          background: #eee;
          border-radius: 5px;
        "
      >
        <img
          :src="currentImage"
          alt="Upload Product Image"
          style="height: 250px; margin-bottom: -10px"
        />
        <div
          style="
            background: #00000036;
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
          "
          :style="{ opacity: showUpload ? 1 : 0 }"
          @mouseover="showUpload = true"
          @mouseleave="showUpload = false"
        >
          <p
            class="text-xs-center"
            style="
              position: absolute;
              top: 50%;
              left: 0;
              right: 0;
              margin-top: -26px;
            "
          >
            <v-btn
              dark
              :color="theme.color"
              @click="onClickUploadFile()"
              :loading="loading"
            >
              <v-icon class="mr-2">mdi-camera</v-icon>
              {{ $t('Select file to upload2') }}
            </v-btn>
            <br />
            <span class="caption white--text">
              {{ $t('Upload file size: {size}MB', { size: 20 }) }}
            </span>
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        style="
          height: 250px;
          background: #eee;
          overflow: hidden;
          position: relative;
        "
        :style="{ height: height + 'px' }"
      >
        <template v-if="loading">
          <div
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -10px;
              margin-left: -21px;
            "
          >
            <sync-loader
              :key="theme.color"
              :color="theme.color"
              :size="'10px'"
            ></sync-loader>
          </div>
        </template>
        <template v-else>
          <p
            class="text-xs-center"
            style="
              position: absolute;
              top: 50%;
              left: 0;
              right: 0;
              margin-top: -26px;
            "
          >
            <v-btn
              dark
              :color="theme.color"
              @click="onClickUploadFile()"
              :loading="loading"
            >
              <v-icon class="mr-2">mdi-camera</v-icon>
              {{ $t('Select file to upload2') }}
            </v-btn>
            <br />
            <span class="caption">
              {{ $t('Upload file size: {size}MB', { size: 20 }) }}
            </span>
          </p>
        </template>
      </div>
    </template>

    <input
      type="file"
      :multiple="!isAndroidOS"
      v-show="false"
      ref="inputUpload"
      class="form-control-file pt-2"
      name="photoUpload"
      id="photoUploadInput"
      data-vv-as="File"
      v-validate="'image|size:20480'"
      :key="`upload_${uploadtimestamp}`"
      @change="onFileChange($event)"
      style="
        overflow: hidden;
        position: fixed;
        width: 1px;
        height: 1px;
        z-index: -1;
        opacity: 0;
      "
    />

    <div class="has-error" v-if="isAlert">
      <p class="text-error">
        {{ $t('Something went wrong. Please try it again.') }}
      </p>
    </div>
    <div class="has-error">
      <p class="text-error" v-show="errors.has('photoUpload')">
        {{ errors.first('photoUpload') }}
      </p>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'
import Jimp from 'jimp'
import jsQR from 'jsqr'
import QrCode from 'qrcode-reader'

export default {
  props: {
    value: null,
    height: {
      default: 100,
      type: Number
    },
    outputtype: {
      default: 'url',
      type: String
    },
    verifyData: {
      default: null
    }
  },
  data: function () {
    return {
      checkSlip: false,
      base64img: '',
      showUpload: false,
      currentImage: this.value,
      isAlert: false,
      config: {
        color: config.color
      },
      loading: false,
      uploadtimestamp: moment().format('x')
    }
  },
  components: {
    SyncLoader
  },
  computed: {
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    ...mapGetters({
      theme: 'getTheme',
      pageProfile: 'getPageProfile'
    }),
    isAndroidOS() {
      let isAndriod = false
      const userAgent = navigator.userAgent || navigator.vendor || window.opera

      if (/windows phone/i.test(userAgent)) {
        isAndriod = true
      }

      if (/android/i.test(userAgent)) {
        isAndriod = true
      }

      return isAndriod
    }
  },
  async mounted() {},
  methods: {
    READ_TRANSFER_SLIP(path) {
      const vm = this
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: path,
          responseType: 'arraybuffer'
        })
          .then(({ data: imageBuffer }) => {
            Jimp.read(imageBuffer, (error, image) => {
              if (error) {
                // eslint-disable-next-line no-console
                console.log(
                  `[debug] slip_verification READ_TRANSFER_SLIP Jimp error`,
                  JSON.stringify(error)
                )
                vm.$emit('verifyDataClick', { eventClick: 'select' })
                resolve(false)
              } else {
                const processedImage = image
                  .rgba(false)
                  .grayscale()
                  .contrast(1)
                  .posterize(2)

                const code = jsQR(
                  Uint8ClampedArray.from(processedImage.bitmap.data),
                  processedImage.bitmap.width,
                  processedImage.bitmap.height
                )
                if (code && code.data) {
                  resolve(code.data)
                } else {
                  // eslint-disable-next-line no-console
                  console.log(
                    `[debug] slip_verification READ_TRANSFER_SLIP code error`,
                    JSON.stringify(code)
                  )
                  const qr = new QrCode()
                  qr.callback = (error, data) => {
                    if (error) {
                      // eslint-disable-next-line no-console
                      console.log(
                        `[debug] slip_verification READ_TRANSFER_SLIP code 2 error ${path}`,
                        JSON.stringify(error)
                      )
                      vm.$emit('verifyDataClick', { eventClick: 'select' })
                      resolve(false)
                    } else {
                      resolve(data.result)
                    }
                  }
                  qr.decode(processedImage.bitmap)
                }
              }
            })
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(
              `[debug] slip_verification READ_TRANSFER_SLIP arraybuffer error`,
              JSON.stringify(error)
            )
            vm.$emit('verifyDataClick', { eventClick: 'select' })
            resolve(false)
          })
      })
    },
    async onClickUploadFile() {
      this.uploadtimestamp = moment().format('x')
      if (navigator.userAgent.match(/FB/)) {
        //
      }
      await this.$nextTick()
      this.$refs.inputUpload.multiple = true
      await this.$nextTick()
      this.$refs.inputUpload.click()
    },
    onClickUploadBtn() {
      document.getElementById('photoUploadInput').click()
    },
    fileResize(file) {
      if ('FileReader' in window) {
        let vm = this

        if (!FileReader) {
          vm.$swal({
            title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            type: 'error',
            text: vm.$t(
              'Your device is unable to read the file. Please contact the shop to proceed with the payment'
            ),
            confirmButtonText: vm.$t('Confirm')
          })
          return null
        }

        return new Promise((resolve, reject) => {
          var reader = new FileReader()
          reader.onloadend = function () {
            var tempImg = new Image()
            tempImg.src = reader.result
            tempImg.onload = async function () {
              var MAX_WIDTH = 1000
              var MAX_HEIGHT = 1000
              if (vm.pageProfile.type == 'monobo') {
                MAX_WIDTH = 500
                MAX_HEIGHT = 500
              }
              var tempW = tempImg.width
              var tempH = tempImg.height
              if (tempW > tempH) {
                if (tempW > MAX_WIDTH) {
                  tempH *= MAX_WIDTH / tempW
                  tempW = MAX_WIDTH
                }
              } else {
                if (tempH > MAX_HEIGHT) {
                  tempW *= MAX_HEIGHT / tempH
                  tempH = MAX_HEIGHT
                }
              }
              var canvas = document.createElement('canvas')
              canvas.width = tempW
              canvas.height = tempH
              var ctx = canvas.getContext('2d')
              ctx.drawImage(this, 0, 0, tempW, tempH)
              var dataURL = canvas.toDataURL('image/jpeg')
              var data = 'image=' + dataURL
              try {
                if (vm.outputtype == 'base64') {
                  vm.$emit('input', dataURL)
                  vm.currentImage = dataURL
                }
                var obj = vm.dataURItoBlob(data)
                obj.name = file.name

                const qr_code_data = await vm.READ_TRANSFER_SLIP(dataURL)
                const is_valid_result =
                  qr_code_data &&
                  typeof qr_code_data === 'string' &&
                  qr_code_data.includes('00060000010103') &&
                  !qr_code_data.includes('/')
                vm.checkSlip = is_valid_result
                if (is_valid_result) {
                  const bank_code = qr_code_data
                    .split('00060000010103')[1]
                    .substring(0, 3)
                  const ref_length = parseInt(
                    qr_code_data.split(bank_code + '02')[1].substring(0, 2)
                  )
                  const ref = qr_code_data
                    .split(bank_code + '02')[1]
                    .substring(2, ref_length + 2)
                  vm.$emit('update:verifyData', {
                    verify_slip_bank_code: bank_code,
                    verify_slip_ref: ref
                  })

                  vm.$emit('verifyDataClick', {
                    verify_slip_bank_code: bank_code,
                    verify_slip_ref: ref
                  })
                }
                resolve(obj)
              } catch (error) {
                vm.$swal({
                  title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
                  type: 'error',
                  text: `dataURItoBlob: ${error}`,
                  confirmButtonText: vm.$t('Confirm')
                })
                reject()
              }
            }
          }
          reader.readAsDataURL(file)
        })
      } else {
        return file
      }
    },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function (event) {
      const vm = this
      vm.isAlert = false

      const result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        vm.uploadtimestamp = moment().format('x')
        return
      } else {
        vm.loading = true
        let files = event.target.files || event.dataTransfer.files
        if (!files.length) {
          vm.uploadtimestamp = moment().format('x')
          return
        }
        try {
          var obj = await vm.fileResize(files[0])
          if (vm.outputtype != 'base64') {
            vm.createImage(obj)
          }
          event.target.value = ''
        } catch (error) {
          vm.loading = false
          vm.$swal({
            title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
            type: 'error',
            text: `fileResize: ${error}`,
            confirmButtonText: this.$t('Confirm')
          })
        }
      }
    },
    createImage(file) {
      // let reader = new FileReader();

      try {
        this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    async upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      vm.loading = true

      let serverUrl =
        vm.pageProfile.type == 'thaiairways'
          ? `${config.thaiairways.serverUrl}`
          : `${config.getConfig('serverUrl')}`
      let url = `${serverUrl}sign-s3?file-name=${data.name}&file-type=${data.type}`
      try {
        var response = await axios.get(url)
        response = response.data
        response.file = data.file
        await this.uploadfile(response)
        vm.currentImage = response.url
        vm.loading = false
        vm.uploadtimestamp = moment().format('x')
        vm.$emit('input', vm.currentImage)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `uploadfile: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
        vm.loading = false
        vm.isAlert = true
      }
    },
    uploadfile: function (data) {
      return new Promise((resolve, reject) => {
        let signedRequest = data.signedRequest
        let request = data.file
        const xhr = new XMLHttpRequest()
        xhr.open('PUT', signedRequest)
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve()
            } else {
              reject('Could not upload file.')
            }
          }
        }
        xhr.send(request)
      })
    }
  },
  watch: {
    value: function (newVal) {
      this.currentImage = newVal
    }
  }
}
</script>
